import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, MessageCircleIcon } from 'lucide-react';
import { WHATSAPP_NUMBER, whatsappLink } from '../lib/whatsapp';
import { useLanguage } from '../lib/i18n';
export function Contact() {
  const {
    t,
    lang
  } = useLanguage();
  const experienceOptions = [t('contact.opt1'), t('contact.opt2'), t('contact.opt3')];
  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
    experience: experienceOptions[0],
    message: ''
  });
  const update = (k: keyof typeof form) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => setForm(f => ({
    ...f,
    [k]: e.target.value
  }));
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const lines = [`Hola! Quiero reservar una experiencia ✨`, ``, `• Nombre: ${form.name || '—'}`, `• Experiencia: ${form.experience}`, form.phone ? `• Teléfono: ${form.phone}` : '', form.email ? `• Email: ${form.email}` : '', form.message ? `\n${form.message}` : ''].filter(Boolean).join('\n');
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(lines)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  return <section id="contacto" className="bg-volcanic text-ivory px-5 sm:px-8 lg:px-24 py-16 sm:py-24 lg:py-32 w-full overflow-hidden" data-id="element-22" data-mp="3153agn6z8f49">
      <div className="grid lg:grid-cols-2 gap-12 sm:gap-16 lg:gap-24 max-w-[1400px] mx-auto" data-id="element-23" data-mp="364zfmpreucle">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 1.2,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-24" data-mp="2s5gggmgkubl8">
          <p className="uppercase tracking-[0.3em] text-olive text-[9px] sm:text-[10px] font-semibold mb-4 sm:mb-6" data-id="element-25" data-mp="23c3p1m1u0zc2">
            {t('contact.tag')}
          </p>
          <h2 className="font-display text-fluid-h2 leading-[1.1] font-light mb-6 sm:mb-10" data-id="element-26" data-mp="1yeu1kby06xqv">
            {t('contact.title1')} <br data-id="element-27" data-mp="1pbsxshwm1iqd" />
            <span className="font-script text-fluid-script text-terracotta inline-block mt-[-0.1em]" data-id="element-28" data-mp="1pccbtnj53mz4">
              {t('contact.title2')}
            </span>
          </h2>
          <p className="max-w-md leading-relaxed text-ivory/90 mb-8 sm:mb-12 font-light text-[14px] sm:text-[15px]" data-id="element-29" data-mp="2m3wjlkwjuslw">
            {t('contact.desc')}
          </p>

          <div className="space-y-4 sm:space-y-5 text-[13px] sm:text-sm" data-id="element-30" data-mp="2d86yze2xe29k">
            <div className="flex items-center gap-3 sm:gap-4 text-ivory/90" data-id="element-31" data-mp="28bghqnfdx0mk">
              <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-terracotta/20 flex items-center justify-center flex-shrink-0" data-id="element-32" data-mp="35psvdm7zgwag">
                <CheckCircleIcon size={12} strokeWidth={2} className="text-terracotta sm:w-3.5 sm:h-3.5" data-id="element-33" data-mp="30yki2f3j8qs0" />
              </div>
              <span className="font-light" data-id="element-34" data-mp="3dan037amohyf">{t('contact.b1')}</span>
            </div>
            <div className="flex items-center gap-3 sm:gap-4 text-ivory/90" data-id="element-35" data-mp="3i8ez0l9ox4c4">
              <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-terracotta/20 flex items-center justify-center flex-shrink-0" data-id="element-36" data-mp="3ma095yuub4im">
                <CheckCircleIcon size={12} strokeWidth={2} className="text-terracotta sm:w-3.5 sm:h-3.5" data-id="element-37" data-mp="3r8bk6cwvfl2f" />
              </div>
              <span className="font-light" data-id="element-38" data-mp="4utfag99kkbk">{t('contact.b2')}</span>
            </div>
            <div className="flex items-center gap-3 sm:gap-4 text-ivory/90" data-id="element-39" data-mp="9td2ejzlg25i">
              <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-terracotta/20 flex items-center justify-center flex-shrink-0" data-id="element-40" data-mp="dugldfcxueay">
                <CheckCircleIcon size={12} strokeWidth={2} className="text-terracotta sm:w-3.5 sm:h-3.5" data-id="element-41" data-mp="isrq5bodlymb" />
              </div>
              <span className="font-light" data-id="element-42" data-mp="160qwfgxupxd">{t('contact.b3')}</span>
            </div>
          </div>

          <a href={whatsappLink('contact', lang)} target="_blank" rel="noopener noreferrer" className="mt-8 sm:mt-12 inline-flex items-center justify-center gap-3 border border-ivory/30 hover:bg-ivory/10 px-6 sm:px-8 py-3.5 sm:py-4 rounded-md text-[13px] sm:text-sm transition-colors duration-300 font-light w-full sm:w-auto" data-id="element-43" data-mp="ewvt58wxm8rz">
            <MessageCircleIcon size={16} strokeWidth={1.5} className="sm:w-[18px] sm:h-[18px]" data-id="element-44" data-mp="3sc1vq6ab8nak" />
            <span data-id="element-45" data-mp="3nb4ebvx4jxa4">{t('contact.btnDirect')}</span>
          </a>
        </motion.div>

        <motion.form initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 1.2,
        delay: 0.2,
        ease: [0.22, 1, 0.36, 1]
      }} onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 text-[13px] sm:text-sm" data-id="element-46" data-mp="17jq9puqmoo06">
          <div data-id="element-47" data-mp="2gk2vsqbda8zx">
            <label className="block mb-2 sm:mb-3 text-[10px] sm:text-xs text-ivory/70 uppercase tracking-[0.2em] font-medium" data-id="element-48" data-mp="347swk2nmvs8t">
              {t('contact.name')}
            </label>
            <input type="text" value={form.name} onChange={update('name')} placeholder={t('contact.namePh')} className="bg-transparent border-b border-ivory/30 w-full pb-2 sm:pb-3 outline-none placeholder:text-ivory/40 focus:border-terracotta transition-colors duration-300 font-light" data-id="element-49" data-mp="38b8o4kkuj2en" />
          </div>
          <div data-id="element-50" data-mp="3rypvmeubyv2n">
            <label className="block mb-2 sm:mb-3 text-[10px] sm:text-xs text-ivory/70 uppercase tracking-[0.2em] font-medium" data-id="element-51" data-mp="3rz81m36sonnr">
              {t('contact.phone')}
            </label>
            <input type="tel" value={form.phone} onChange={update('phone')} placeholder={t('contact.phonePh')} className="bg-transparent border-b border-ivory/30 w-full pb-2 sm:pb-3 outline-none placeholder:text-ivory/40 focus:border-terracotta transition-colors duration-300 font-light" data-id="element-52" data-mp="poc9u20rce5" />
          </div>
          <div data-id="element-53" data-mp="3e287arsibbei">
            <label className="block mb-2 sm:mb-3 text-[10px] sm:text-xs text-ivory/70 uppercase tracking-[0.2em] font-medium" data-id="element-54" data-mp="3e1q1b3g1lite">
              {t('contact.email')}
            </label>
            <input type="email" value={form.email} onChange={update('email')} placeholder={t('contact.emailPh')} className="bg-transparent border-b border-ivory/30 w-full pb-2 sm:pb-3 outline-none placeholder:text-ivory/40 focus:border-terracotta transition-colors duration-300 font-light" data-id="element-55" data-mp="3476hdtqeq5av" />
          </div>
          <div data-id="element-56" data-mp="1en6ii86qvder">
            <label className="block mb-2 sm:mb-3 text-[10px] sm:text-xs text-ivory/70 uppercase tracking-[0.2em] font-medium" data-id="element-57" data-mp="1emoh6x5868zz">
              {t('contact.exp')}
            </label>
            <select value={form.experience} onChange={update('experience')} className="bg-transparent border-b border-ivory/30 w-full pb-2 sm:pb-3 outline-none text-ivory focus:border-terracotta transition-colors duration-300 font-light" data-id="element-58" data-mp="1olcniynukznu">
              {experienceOptions.map(opt => <option key={opt} className="text-volcanic bg-sand" data-id="element-59" data-mp="15nt89dasqksz">
                  {opt}
                </option>)}
            </select>
          </div>
          <div className="md:col-span-2" data-id="element-60" data-mp="885my3lmsx8p">
            <label className="block mb-2 sm:mb-3 text-[10px] sm:text-xs text-ivory/70 uppercase tracking-[0.2em] font-medium" data-id="element-61" data-mp="d78tjsh9fbis">
              {t('contact.msg')}
            </label>
            <textarea rows={4} value={form.message} onChange={update('message')} placeholder={t('contact.msgPh')} className="bg-transparent border-b border-ivory/30 w-full pb-2 sm:pb-3 outline-none placeholder:text-ivory/40 resize-none focus:border-terracotta transition-colors duration-300 font-light" data-id="element-62" data-mp="32rf0pr3kskt7" />
          </div>
          <div className="md:col-span-2 flex justify-end pt-4 sm:pt-6" data-id="element-63" data-mp="3gpd2zy4mgqsc">
            <button type="submit" className="inline-flex items-center justify-center gap-3 bg-terracotta hover:bg-terracottaDark transition-colors duration-300 px-8 sm:px-12 py-4 sm:py-5 rounded-md uppercase tracking-[0.15em] sm:tracking-[0.2em] text-[10px] sm:text-xs w-full sm:w-auto" data-id="element-64" data-mp="3gp3d0ajkujmn">
              <MessageCircleIcon size={16} strokeWidth={1.5} className="sm:w-[18px] sm:h-[18px]" data-id="element-65" data-mp="3agtwybhz1k7" />
              <span data-id="element-66" data-mp="mws2cxejo8tl">{t('contact.btn')}</span>
            </button>
          </div>
        </motion.form>
      </div>
    </section>;
}